export enum CostAssignmentType {
  /** Leistungsbetrag der Pflegekasse § 43 SGB XI */
  BENEFIT_AMOUNT = 'BENEFIT_AMOUNT',

  /** Leistungszuschlag nach § 43c SGB XI */
  SUPPLEMENT_43C = 'SUPPLEMENT_43C',

  /** Vergütungszuschlag nach § 43b SGB XI (§ 84 Abs. 8) [HVP: EAB] */
  SURCHARGE_43B = 'SURCHARGE_43B',

  /** Vergütungszuschlag nach § 132g Abs. 3 SGB V */
  SURCHARGE_84_9 = 'SURCHARGE_84_9',

  /** Pflegewohngeld des Sozialamtes */
  NURSING_HOME_ALLOWANCE = 'NURSING_HOME_ALLOWANCE',

  /** Taschengeld des Sozialamtes */
  MONTHLY_INCOMING_SUPPORT = 'MONTHLY_INCOMING_SUPPORT',

  /** Sozialhilfe */
  SOCIAL_ASSISTANCE = 'SOCIAL_ASSISTANCE',

  /** Monatlicher Geldeingang */
  MONTHLY_INCOMING_FUND = 'MONTHLY_INCOMING_FUND',

  WITHOUT_MONTHLY_INCOMING_FUND = 'WITHOUT_MONTHLY_INCOMING_FUND',

  /**Investitionskostenzuschlag */
  INVESTMENT_COST_SUPPLEMENT = 'INVESTMENT_COST_SUPPLEMENT',
}

const CostAssignmentTypeObject = {
  /** Leistungsbetrag der Pflegekasse § 43 SGB XI */
  BENEFIT_AMOUNT: 'BENEFIT_AMOUNT',

  /** Leistungszuschlag nach § 43c SGB XI */
  SUPPLEMENT_43C: 'SUPPLEMENT_43C',

  /** Vergütungszuschlag nach § 43b SGB XI (§ 84 Abs. 8) [HVP: EAB] */
  SURCHARGE_43B: 'SURCHARGE_43B',

  /** Vergütungszuschlag nach § 132g Abs. 3 SGB V */
  SURCHARGE_84_9: 'SURCHARGE_84_9',

  /** Pflegewohngeld des Sozialamtes */
  NURSING_HOME_ALLOWANCE: 'NURSING_HOME_ALLOWANCE',

  /** Taschengeld des Sozialamtes */
  MONTHLY_INCOMING_SUPPORT: 'MONTHLY_INCOMING_SUPPORT',

  /** Sozialhilfe */
  SOCIAL_ASSISTANCE: 'SOCIAL_ASSISTANCE',

  /** Monatlicher Geldeingang */
  MONTHLY_INCOMING_FUND: 'MONTHLY_INCOMING_FUND',

  WITHOUT_MONTHLY_INCOMING_FUND: 'WITHOUT_MONTHLY_INCOMING_FUND',

  /**Investitionskostenzuschlag */
  INVESTMENT_COST_SUPPLEMENT: 'INVESTMENT_COST_SUPPLEMENT',
} as const;

export const CostBearerWithCostAssignmentTypeObject = {
  ...CostAssignmentTypeObject,
} as const;

export type CostBearerWithCostAssignmentTypeObjectEnum =
  typeof CostBearerWithCostAssignmentTypeObject[keyof typeof CostBearerWithCostAssignmentTypeObject];
